import axios from "../utils/axios";

const API_URL = "/api/staff";

// Create Staff
export const createStaffApi = async (formData) => {
  const { data } = await axios.post(API_URL, formData);
  return data;
};

// Get All Staff
export const getStaffApi = async (params) => {
  const { data } = await axios.get(API_URL, { params });
  return data;
};

// Get Staff By ID
export const getStaffByIdApi = async (id) => {
  const { data } = await axios.get(`${API_URL}/${id}`);
  return data;
};

// Update Staff
export const updateStaffApi = async (id, formData) => {
  const { data } = await axios.put(`${API_URL}/update/${id}`, formData);
  return data;
};

// Update Permissions
export const updateStaffPermissionsApi = async (id, permissions) => {
  const { data } = await axios.put(
    `${API_URL}/${id}/permissions`,
    { permissions }
  );
  return data;
};

// Toggle Status
export const toggleStaffStatusApi = async (id) => {
  const { data } = await axios.patch(`${API_URL}/${id}/toggle-status`);
  return data;
};

// Delete Staff
export const deleteStaffApi = async (id) => {
  const { data } = await axios.delete(`${API_URL}/${id}`);
  return data;
};

// ══════════════════════════════════════════════════════════════════
// STAFF AUTH APIs
// ══════════════════════════════════════════════════════════════════

export const staffLoginApi = async (form) => {
  const { data } = await axios.post(`${API_URL}/login`, form);
  return data;
};